import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]
  static values = {
    defaultCountry: { type: String, default: "de" },
    preferredCountries: { type: Array, default: ["de", "at", "ch"] },
    initialValue: String,
    phoneNumber: String
  }

  connect() {
    // Für Display-Elemente: Füge Telefonsymbol hinzu
    if (this.hasDisplayTarget) {
      this.addPhoneIcon()
    }
    
    // Für alle Elemente mit data-phone-number-display: Suche nach tel: Links und füge Icons hinzu
    this.addPhoneIconsToDisplayElements()
  }

  disconnect() {
    // Cleanup wird später implementiert
  }

  addPhoneIcon() {
    const displayElement = this.displayTarget
    const phoneNumber = this.phoneNumberValue || this.extractPhoneNumber(displayElement)
    
    // Nur wenn eine Telefonnummer vorhanden ist und noch kein Icon existiert
    if (phoneNumber && phoneNumber.trim().length > 0 && !this.hasPhoneIcon(displayElement)) {
      const iconLink = this.createPhoneIconLink(phoneNumber.trim())
      displayElement.appendChild(iconLink)
    }
  }

  addPhoneIconsToDisplayElements() {
    // Suche nach allen tel: Links im Element
    const telLinks = this.element.querySelectorAll('a[href^="tel:"]')
    
    telLinks.forEach(link => {
      const phoneNumber = link.getAttribute('href').replace('tel:', '').trim()
      
      // Nur wenn eine Telefonnummer vorhanden ist und noch kein Icon existiert
      if (phoneNumber && phoneNumber.length > 0 && !this.hasPhoneIcon(link.parentElement)) {
        const iconLink = this.createPhoneIconLink(phoneNumber)
        
        // Füge das Icon nach dem Link hinzu
        if (link.nextSibling) {
          link.parentElement.insertBefore(iconLink, link.nextSibling)
        } else {
          link.parentElement.appendChild(iconLink)
        }
      }
    })
  }

  extractPhoneNumber(element) {
    // Versuche, die Telefonnummer aus dem Element zu extrahieren
    const telLink = element.querySelector('a[href^="tel:"]')
    if (telLink) {
      return telLink.getAttribute('href').replace('tel:', '')
    }
    
    // Versuche, die Nummer aus dem Text zu extrahieren
    const text = element.textContent || ''
    const phoneMatch = text.match(/[\d\s\+\-\(\)]+/)
    return phoneMatch ? phoneMatch[0].trim() : null
  }

  hasPhoneIcon(container) {
    // Prüfe, ob bereits ein Telefonsymbol vorhanden ist
    return container.querySelector('.phone-icon-link') !== null ||
           container.querySelector('a[href^="tel:"] .fa-phone') !== null ||
           container.querySelector('a[href^="tel:"] .fas.fa-phone') !== null
  }

  createPhoneIconLink(phoneNumber) {
    const iconLink = document.createElement('a')
    iconLink.href = `tel:${phoneNumber}`
    iconLink.className = 'phone-icon-link inline-flex items-center ml-2 text-blue-600 hover:text-blue-800'
    iconLink.title = 'Anrufen'
    iconLink.innerHTML = '<i class="fas fa-phone text-sm"></i>'
    return iconLink
  }
}

